import { rootApi } from "../../api/rootApi";

export const centuryApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCenturyPointLedger: builder.mutation({
      query: (payload) => ({
        url: `tenant/century/point/ledger`,
        method: "POST",
        headers: {
          slug: payload.slug,
          Authorization: `Bearer ${payload.token}`,
        },
        body: payload.body,
      }),
    }),
    fetchCenturyProductLedger: builder.mutation({
      query: (payload) => ({
        url: `tenant/century/product/ledger`,
        method: "POST",
        headers: {
          slug: payload.slug,
          Authorization: `Bearer ${payload.token}`,
        },
        body: payload.body,
      }),
    }),
    fetchCenturyUpiLedger: builder.mutation({
      query: (payload) => ({
        url: `tenant/century/upi/ledger`,
        method: "POST",
        headers: {
          slug: payload.slug,
          Authorization: `Bearer ${payload.token}`,
        },
        body: payload.body,
      }),
    }),
    fetchCenturyAuditTrail: builder.mutation({
      query: (payload) => ({
        url: `tenant/century/audit-trail`,
        method: "POST",
        headers: {
          slug: payload.slug,
          Authorization: `Bearer ${payload.token}`,
        },
        body: payload.body,
      }),
    }),
    fetchCenturyExpiryPointsLedger: builder.mutation({
      query: (payload) => ({
        url: `tenant/century/expiry-points-ledger`,
        method: "POST",
        headers: {
          slug: payload.slug,
          Authorization: `Bearer ${payload.token}`,
        },
        body: payload.body,
      }),
    }),
  }),
});

export const {
  useFetchCenturyPointLedgerMutation,
  useFetchCenturyProductLedgerMutation,
  useFetchCenturyUpiLedgerMutation,
  useFetchCenturyAuditTrailMutation,
  useFetchCenturyExpiryPointsLedgerMutation,
} = centuryApi;


